"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyIpCodesSummaryByIpInfo = exports.StudyIpCodeSummary = exports.StudyIpReturnDetail = exports.StudyIpReturn = exports.StudyIpReturnStatus = exports.StudyIpReturnType = exports.StudyIpAccountabilityBySubjectType = exports.StudyIpCodeLog = exports.StudyIpCode = exports.StudyIpCodeLogFactoryReturnStatus = exports.StudyIpCodeLogReturnStatus = exports.StudyIpCodeLogDispenseStatus = exports.StudyIpCodeReturnStatus = exports.StudyIpCodeDispenseStatus = exports.StudyIpCodeDisableReason = exports.StudyIpDelivery = exports.StudyIpDeliveryStatus = exports.StudyIpAutoCondition = exports.StudyIpAutoConditionStatus = exports.StudyIpInfo = exports.StudyIpInfoType = void 0;
var StudyIpInfoType;
(function (StudyIpInfoType) {
    StudyIpInfoType["RunIn"] = "RUN_IN";
    StudyIpInfoType["Treatment"] = "TREATMENT";
})(StudyIpInfoType = exports.StudyIpInfoType || (exports.StudyIpInfoType = {}));
class StudyIpInfo {
}
exports.StudyIpInfo = StudyIpInfo;
var StudyIpAutoConditionStatus;
(function (StudyIpAutoConditionStatus) {
    StudyIpAutoConditionStatus["On"] = "ON";
    StudyIpAutoConditionStatus["Off"] = "OFF";
})(StudyIpAutoConditionStatus = exports.StudyIpAutoConditionStatus || (exports.StudyIpAutoConditionStatus = {}));
class StudyIpAutoCondition {
}
exports.StudyIpAutoCondition = StudyIpAutoCondition;
var StudyIpDeliveryStatus;
(function (StudyIpDeliveryStatus) {
    StudyIpDeliveryStatus["AutoRequested"] = "AUTO_REQUESTED";
    StudyIpDeliveryStatus["Requested"] = "REQUESTED";
    StudyIpDeliveryStatus["Canceled"] = "CANCELED";
    StudyIpDeliveryStatus["Approved"] = "APPROVED";
    StudyIpDeliveryStatus["Started"] = "STARTED";
    StudyIpDeliveryStatus["Delivered"] = "DELIVERED";
})(StudyIpDeliveryStatus = exports.StudyIpDeliveryStatus || (exports.StudyIpDeliveryStatus = {}));
class StudyIpDelivery {
}
exports.StudyIpDelivery = StudyIpDelivery;
var StudyIpCodeDisableReason;
(function (StudyIpCodeDisableReason) {
    StudyIpCodeDisableReason["DeliveryOmit"] = "DELIVERY_OMIT";
    StudyIpCodeDisableReason["DeliveryLoss"] = "DELIVERY_LOSS";
    StudyIpCodeDisableReason["DeliveryDamaged"] = "DELIVERY_DAMAGED";
    StudyIpCodeDisableReason["Misdispense"] = "MISDISPENSE";
    StudyIpCodeDisableReason["Loss"] = "LOSS";
    StudyIpCodeDisableReason["Damaged"] = "DAMAGED";
    StudyIpCodeDisableReason["Unused"] = "UNUSED";
})(StudyIpCodeDisableReason = exports.StudyIpCodeDisableReason || (exports.StudyIpCodeDisableReason = {}));
var StudyIpCodeDispenseStatus;
(function (StudyIpCodeDispenseStatus) {
    StudyIpCodeDispenseStatus["NotAvailable"] = "NOT_AVAILABLE";
    StudyIpCodeDispenseStatus["Wait"] = "WAIT";
    StudyIpCodeDispenseStatus["Processing"] = "PROCESSING";
    StudyIpCodeDispenseStatus["Processed"] = "PROCESSED";
})(StudyIpCodeDispenseStatus = exports.StudyIpCodeDispenseStatus || (exports.StudyIpCodeDispenseStatus = {}));
var StudyIpCodeReturnStatus;
(function (StudyIpCodeReturnStatus) {
    StudyIpCodeReturnStatus["NotAvailable"] = "NOT_AVAILABLE";
    StudyIpCodeReturnStatus["Wait"] = "WAIT";
    StudyIpCodeReturnStatus["Requested"] = "REQUESTED";
    StudyIpCodeReturnStatus["Processed"] = "PROCESSED";
})(StudyIpCodeReturnStatus = exports.StudyIpCodeReturnStatus || (exports.StudyIpCodeReturnStatus = {}));
var StudyIpCodeLogDispenseStatus;
(function (StudyIpCodeLogDispenseStatus) {
    StudyIpCodeLogDispenseStatus["NotAvailable"] = "NOT_AVAILABLE";
    StudyIpCodeLogDispenseStatus["Wait"] = "WAIT";
    StudyIpCodeLogDispenseStatus["Processed"] = "PROCESSED";
})(StudyIpCodeLogDispenseStatus = exports.StudyIpCodeLogDispenseStatus || (exports.StudyIpCodeLogDispenseStatus = {}));
var StudyIpCodeLogReturnStatus;
(function (StudyIpCodeLogReturnStatus) {
    StudyIpCodeLogReturnStatus["NotAvailable"] = "NOT_AVAILABLE";
    StudyIpCodeLogReturnStatus["Wait"] = "WAIT";
    StudyIpCodeLogReturnStatus["Processed"] = "PROCESSED";
})(StudyIpCodeLogReturnStatus = exports.StudyIpCodeLogReturnStatus || (exports.StudyIpCodeLogReturnStatus = {}));
var StudyIpCodeLogFactoryReturnStatus;
(function (StudyIpCodeLogFactoryReturnStatus) {
    StudyIpCodeLogFactoryReturnStatus["NotAvailable"] = "NOT_AVAILABLE";
    StudyIpCodeLogFactoryReturnStatus["Wait"] = "WAIT";
    StudyIpCodeLogFactoryReturnStatus["Requested"] = "REQUESTED";
    StudyIpCodeLogFactoryReturnStatus["Processed"] = "PROCESSED";
})(StudyIpCodeLogFactoryReturnStatus = exports.StudyIpCodeLogFactoryReturnStatus || (exports.StudyIpCodeLogFactoryReturnStatus = {}));
class StudyIpCode {
}
exports.StudyIpCode = StudyIpCode;
class StudyIpCodeLog {
}
exports.StudyIpCodeLog = StudyIpCodeLog;
var StudyIpAccountabilityBySubjectType;
(function (StudyIpAccountabilityBySubjectType) {
    StudyIpAccountabilityBySubjectType["Dispense"] = "DISPENSE";
    StudyIpAccountabilityBySubjectType["Return"] = "RETURN";
})(StudyIpAccountabilityBySubjectType = exports.StudyIpAccountabilityBySubjectType || (exports.StudyIpAccountabilityBySubjectType = {}));
var StudyIpReturnType;
(function (StudyIpReturnType) {
    StudyIpReturnType["Unused"] = "UNUSED";
    StudyIpReturnType["Used"] = "USED";
})(StudyIpReturnType = exports.StudyIpReturnType || (exports.StudyIpReturnType = {}));
var StudyIpReturnStatus;
(function (StudyIpReturnStatus) {
    StudyIpReturnStatus["Requested"] = "REQUESTED";
    StudyIpReturnStatus["Canceled"] = "CANCELED";
    StudyIpReturnStatus["Returned"] = "RETURNED";
})(StudyIpReturnStatus = exports.StudyIpReturnStatus || (exports.StudyIpReturnStatus = {}));
class StudyIpReturn {
}
exports.StudyIpReturn = StudyIpReturn;
class StudyIpReturnDetail {
}
exports.StudyIpReturnDetail = StudyIpReturnDetail;
class StudyIpCodeSummary {
}
exports.StudyIpCodeSummary = StudyIpCodeSummary;
class StudyIpCodesSummaryByIpInfo {
}
exports.StudyIpCodesSummaryByIpInfo = StudyIpCodesSummaryByIpInfo;
//# sourceMappingURL=studyIp.js.map